import request from '@/utils/request'

export const syncGlLinks = () => request.post('/accounting/gl-links/sync', {})
